import React, { Component } from 'react';

import Panel from 'common/Panel';
import TitlePanel from 'common/TitlePanel';
import ProfileSettings from './ProfileSettings';
export class Settings extends Component {
  render() {
    return (
      <div data-testid='settings'>
        <TitlePanel className="pa3 flex items-center justify-center">
          <h1 className="tracked mb0">Settings</h1>
        </TitlePanel>
        <Panel className="flex flex-column">
          <ProfileSettings/>
        </Panel>
      </div>
    );
  }
}

export default Settings;
